<div class="title" *ngIf="title">{{ title }}</div>
<div class="title" *ngIf="combinationTitle && combinationTitle.length">
    {{ combinationTitle.join(" & ") }}
</div>
<div class="title" *ngIf="combinationTitle && !combinationTitle.length">
    {{ defaultTitle }}
</div>
<div class="subTitle">{{ subTitle }}</div>
